import { render, staticRenderFns } from "./AdjetivesSumary.vue?vue&type=template&id=5712afa7&scoped=true&functional=true"
var script = {}
import style0 from "./AdjetivesSumary.vue?vue&type=style&index=0&id=5712afa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5712afa7",
  null
  
)

export default component.exports